import { render, staticRenderFns } from "./BookedAwards.vue?vue&type=template&id=f842d068&"
import script from "./BookedAwards.vue?vue&type=script&lang=js&"
export * from "./BookedAwards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports